export default "__VITE_ASSET__Zw7dmbUF__"